import { Course } from '@thro-types/core';

export const sortCourses = (courses: Course[]) =>
  courses.sort((a, b) => {
    const aName = a.shorthand.toUpperCase();
    const bName = b.shorthand.toUpperCase();
    if (aName < bName) {
      return -1;
    } else if (aName > bName) {
      return 1;
    }
    return 0;
  });
